var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CrudTable',_vm._b({attrs:{"storeModule":_vm.storeModule,"adaptableHeight":true,"showActionsPanel":false},scopedSlots:_vm._u([{key:"form",fn:function(ref){
var close = ref.close;
return [_c('TopicForm',{attrs:{"showHeader":""},on:{"close":close}})]}},{key:"item.external_id",fn:function(ref){
var item = ref.item;
return [_c('router-link',{attrs:{"to":{ name: 'TopicDetail', params: { id: item.id }}}},[_vm._v(" "+_vm._s(item.external_id)+" ")])]}}])},'CrudTable',_vm.crudTableConfig,false))}
var staticRenderFns = []

export { render, staticRenderFns }